import { ChevronDown } from "lucide-react";

/**
 * Visual FAQ section — renders open-able questions.
 * The parent should ALSO pass the same `faqs` array to SEO for JSON-LD emission.
 */
export default function FAQSection({ faqs, title = "Frequently asked questions" }) {
  if (!faqs || faqs.length === 0) return null;
  return (
    <section className="mt-14 mb-6" data-testid="faq-section">
      <p className="label-eyebrow text-gray-500 mb-2">Answers</p>
      <h2 className="font-display text-3xl md:text-4xl text-[#7A1E2A] mb-6">{title}</h2>
      <div className="space-y-2">
        {faqs.map(({ q, a }, i) => (
          <details
            key={i}
            className="group rounded-2xl border border-[#EFE3D0] bg-white hover:border-[#7A1E2A]/30 transition-colors overflow-hidden"
            data-testid={`faq-item-${i}`}
          >
            <summary className="cursor-pointer list-none flex items-center justify-between gap-4 px-5 py-4 font-semibold text-[#1B0F14] hover:bg-[#FBF6EC]/50">
              <span>{q}</span>
              <ChevronDown size={18} className="text-[#7A1E2A] transition-transform group-open:rotate-180 shrink-0" />
            </summary>
            <div className="px-5 pb-5 text-gray-700 leading-relaxed">{a}</div>
          </details>
        ))}
      </div>
    </section>
  );
}
